import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetchofflinekampeerplaatsen } from "../../Reducers/actions";

function OfflineMetersNotification({ fetchofflinekampeerplaatsen, offlineKampeerplaatsen }) {
  const [showOfflineDetails, setShowOfflineDetails] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOfflineData = async () => {
      setLoading(true);
      try {
        await fetchofflinekampeerplaatsen(2); // 2 uur threshold
      } catch (error) {
        console.error("Fout bij ophalen offline meters:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOfflineData();

    // Interval om elke 5 minuten opnieuw offline meters op te halen
    const interval = setInterval(fetchOfflineData, 300000); // 5 minuten

    return () => clearInterval(interval);
  }, [fetchofflinekampeerplaatsen]);

  if (loading && !offlineKampeerplaatsen) {
    return (
      <div className="col-12 mb-3">
        <div className="alert alert-info">
          Controleren op offline meters...
        </div>
      </div>
    );
  }

  if (!offlineKampeerplaatsen || offlineKampeerplaatsen.length === 0) {
    return null;
  }

  return (
    <div className="col-12 mb-3">
      <div className="alert alert-warning" role="alert">
        <div 
          onClick={() => setShowOfflineDetails(!showOfflineDetails)}
          style={{ cursor: 'pointer' }}
          className="d-flex justify-content-between align-items-center"
        >
          <div>
            <strong>Waarschuwing:</strong> {offlineKampeerplaatsen.length} meter(s) zijn meer dan 2 uur offline
          </div>
          <span>{showOfflineDetails ? '▼' : '▶'}</span>
        </div>
        {showOfflineDetails && (
          <div className="mt-2 pt-2" style={{ borderTop: '1px solid #f0ad4e' }}>
            <strong>Offline meters:</strong>
            <ul className="mb-0 mt-1">
              {offlineKampeerplaatsen.map((meter, index) => (
                <li key={meter._id || index}>
                  <strong>{meter.naam}</strong>
                  {meter.data && meter.data.length > 0 && (
                    <span className="text-muted ms-2">
                      (Laatste meting: {new Date(meter.data[0].datum).toLocaleString()})
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { 
    offlineKampeerplaatsen: state.standplaatsen.offlineKampeerplaatsen 
  };
}

export default connect(mapStateToProps, { fetchofflinekampeerplaatsen })(OfflineMetersNotification);